import {
  AlignJustify, ArrowRightLeft, Palette, Circle, Shield, TrendingUp,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { DrillType } from './shared';

export const DRILL_ICONS: Record<DrillType, LucideIcon> = {
  lineup:           AlignJustify,
  long_pot:         ArrowRightLeft,
  colors_clearance: Palette,
  baulk_colors:     Circle,
  safety_exchange:  Shield,
  break_building:   TrendingUp,
};